
import { QuestionContent } from "@/types/test";
import { Label } from "@/components/ui/label";
import { useState, useEffect } from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface MultipleChoiceQuestionProps {
  content: QuestionContent;
  response: string;
  onChange: (response: string) => void;
}

export function MultipleChoiceQuestion({
  content,
  response,
  onChange,
}: MultipleChoiceQuestionProps) {
  // Ensure content is properly parsed if it's a string
  const parsedContent = typeof content === 'string' ? JSON.parse(content) : content;
  const [selectedOption, setSelectedOption] = useState<string | null>(response || null);
  
  useEffect(() => {
    if (response) {
      setSelectedOption(response);
    }
  }, [response]);

  const handleOptionChange = (option: string) => {
    setSelectedOption(option);
    onChange(option);
  };
  
  return (
    <div className="space-y-6">
      <h3 className="font-medium text-2xl text-foreground">{parsedContent.question}</h3>
      <div className="space-y-4">
        {parsedContent.options?.map((option: string, index: number) => (
          <div key={index} className="flex items-start space-x-3 p-3 hover:bg-muted/50 rounded-md cursor-pointer" 
               onClick={() => handleOptionChange(option)}>
            <div className="h-5 w-5 mt-0.5 border-2 border-primary flex-shrink-0 rounded-sm flex items-center justify-center">
              {selectedOption === option && (
                <div className="h-3 w-3 bg-primary rounded-sm"></div>
              )}
            </div>
            <Label 
              className="text-foreground text-lg cursor-pointer"
            >
              {option}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
}
